import { PlusSquareOutlined } from '@ant-design/icons';
import { Button, Flex, Space, TableProps, Tag } from 'antd';

import dayjs from 'dayjs';
import { FaRegEdit } from 'react-icons/fa';
import { TActionList } from '../../../common';
import {
  ActionListButton,
  AppDrawer,
  DataTable,
  drawerResource,
  openDrawer,
  useAppDispatch,
  useDrawer,
} from '../../../core';
import { useGetPromoCodesQuery } from '../store/promo-code.api';
import {
  ISubscriptionPromoCode,
  ISubscriptionPromoCodeAttributes,
} from '../types/promo-code.types';
import { CreatePromoCode } from './create';
import { UpdatePromoCode } from './update';

export type TPromoCodeDrawer = 'PromoCodeDrawer';

export const PromoCodeList: React.FC = () => {
  const { data: promoCodes, isLoading } = useGetPromoCodesQuery();
  const dispatch = useAppDispatch();
  const { resource } = useDrawer<ISubscriptionPromoCode>();

  const columns: TableProps<
    ISubscriptionPromoCodeAttributes & { key: string }
  >['columns'] = [
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      render: (type: string) => (
        <Tag color={type === 'percentage' ? 'blue' : 'green'}>
          {type.charAt(0).toUpperCase() + type.slice(1)}
        </Tag>
      ),
    },
    {
      title: 'Value',
      dataIndex: 'value',
      key: 'value',
      render: (value: number, record) => {
        return (
          <span>
            {value}
            {record.type === 'percentage' ? '%' : ' LE'}
          </span>
        );
      },
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
    },
    {
      title: 'Used',
      dataIndex: 'usedCount',
      key: 'used_count',
    },
    {
      title: 'Expires At',
      dataIndex: 'expireAt',
      key: 'expires_at',
      render: (date: string) => dayjs(date).format('MMM D, YYYY'),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => {
        const items: TActionList<ISubscriptionPromoCode>['items'] = [
          {
            key: 'edit',
            label: 'Edit',
            icon: <FaRegEdit />,
            disabled: record.usedCount !== 0,
            action: () => {
              dispatch(drawerResource({ ...record, id: record.key }));
              dispatch(openDrawer('PromoCodeDrawer'));
            },
          },
        ];

        return <ActionListButton items={items} record={record} />;
      },
    },
  ];

  return (
    <>
      <Flex justify="end" align="center" style={{ marginBottom: 16 }}>
        <Space>
          <Button
            type="primary"
            icon={<PlusSquareOutlined />}
            onClick={() => dispatch(openDrawer('PromoCodeDrawer'))}
          >
            Create Promo Code
          </Button>
        </Space>
      </Flex>

      <AppDrawer
        title={resource ? 'Edit Promo Code' : 'Create Promo Code'}
        drawerId="PromoCodeDrawer"
      >
        {resource ? <UpdatePromoCode /> : <CreatePromoCode />}
      </AppDrawer>

      <DataTable
        columns={columns}
        data={promoCodes || []}
        isLoading={isLoading}
      />
    </>
  );
};
